var _style, _g, _g2, _g3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKPosilkow = function SvgKPosilkow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st2{fill:#FFFFFF;}\n\t.st1{fill:#2E2D41;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.8,5.1L18.9,9c-1.1,1.1-2.8,1.1-3.9,0s-1.1-2.8,0-3.9l3.9-3.9L17.7,0l-3.9,3.9c-0.8,0.8-1.3,2-1.3,3.1 s0.5,2.3,1.3,3.1s2,1.3,3.1,1.3c1.2,0,2.3-0.5,3.1-1.3l4-3.8L22.8,5.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.689 10.9246)",
    width: 0.6,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 6,
    transform: "matrix(0.7058 -0.7084 0.7084 0.7058 0.1946 14.1692)",
    className: "st2",
    width: 10.5,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.7,13.5l-3-3l-1.2-1.2l-0.7-0.7L4.9,0.8C4.7,0.6,4.4,0.6,4.2,0.6C3.9,0.7,3.6,0.9,3.6,1.2L2.4,4.6 C1.8,6.5,2.3,8.5,3.7,9.8l8.9,8.9c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2l1.2-1.2l1.2-1.2l0.9-0.9l0.6-0.6 c0.2-0.2,0.3-0.4,0.3-0.6C17.9,13.9,17.8,13.7,17.7,13.5z M13.1,16.9l-0.8-0.8L4.9,8.6C4,7.7,3.6,6.4,4,5.2L4.7,3l10,10l1.2,1.2 L13.1,16.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,23.2c-0.2,0-0.4-0.1-0.6-0.3l-0.2-0.2l-0.6-0.6L15,17.5L14.5,17l1.2-1.2l0.5,0.5l4.8,4.8l0.8-0.9l0,0l0,0L17,15.4 l-0.7-0.7l1.1-1.1l0.1-0.1l0.1,0.1l0,0l4.8,4.8l0.7,0.7l0.5,0.5l0.1,0.1c-0.2,0.8-0.6,1.5-1.1,2.1l-0.8,0.8l-0.1,0.1L21,23.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.7,15.4l-2.1-2.1c-0.3-0.3-0.9-0.3-1.2,0l-0.1,0.1l-7,7C0.1,20.6,0,20.8,0,21s0.1,0.4,0.3,0.6l2.1,2.1 C2.5,23.9,2.7,24,3,24c0.2,0,0.4-0.1,0.6-0.3l7-7l0.2-0.1C11,16.4,11,16.2,11,16C11,15.8,10.9,15.5,10.7,15.4z M3,22l-1-1l6-6 l0.9,1L3,22z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 18,
    cy: 18,
    r: 5.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18,13.6c2.4,0,4.4,2,4.4,4.4s-2,4.4-4.4,4.4s-4.4-2-4.4-4.4S15.6,13.6,18,13.6L18,13.6z M18,12 c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S21.3,12,18,12L18,12z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.5,15.1c-0.5,0-0.8,0.4-0.8,0.8v4.2c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8v-4.2 C17.4,15.5,17,15.1,16.5,15.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.1,15.3c-0.3-0.3-0.8-0.3-1.2,0l-2,2c-0.3,0.3-0.3,0.8,0,1.2c0.3,0.3,0.8,0.3,1.2,0l2-2 C20.4,16.2,20.4,15.7,20.1,15.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.1,20.6c0.3-0.3,0.3-0.8,0-1.2l-2-2c-0.3-0.3-0.8-0.3-1.2,0c-0.3,0.3-0.3,0.8,0,1.2l2,2 C19.2,20.9,19.7,20.9,20.1,20.6z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKPosilkow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/k_posilkow.3c801a8b.svg";
export { ForwardRef as ReactComponent };